import { defineComponent as _defineComponent } from 'vue'
import { ref, inject, computed, getCurrentInstance, Ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveTrackingMapShareButton',
  setup(__props) {

const copied = ref(false)
const trackingLink = inject<Ref<string>>('trackingLink', ref(''))

const instance = getCurrentInstance()
const $t = instance?.proxy?.$t.bind(instance?.proxy) ?? ((x: string) => x)
const $vuetify = instance?.proxy?.$vuetify

const tooltipCopy = computed(() => {
  if ($vuetify?.breakpoint.smAndDown) {
    return $t('liveTracking.actions.SHARE')
  }
  return copied.value
    ? $t('liveTracking.actions.LINK_COPIED')
    : $t('liveTracking.actions.COPY_LINK')
})

async function copyURL() {
  try {
    if ($vuetify?.breakpoint.smAndDown && navigator.share) {
      await navigator.share({
        title: $t('liveTracking.actions.SHARE_TITLE').toString(),
        url: trackingLink as string,
        text: $t('liveTracking.actions.SHARE_TEXT').toString(),
      })
    } else {
      await navigator.clipboard.writeText(trackingLink as string)
    }
    copied.value = true
  } catch (err) {
    console.error(err)
  }
}

return { __sfc: true,copied, trackingLink, instance, $t, $vuetify, tooltipCopy, copyURL }
}

})